<template>
  <!-- 数据管理 - 企业定额数据库 author: zhangxiaofeng-->
  <div class="wrap data-management quota-main" ref="scrollBody" id="scrollBody">
    <div class="content--options" id="contentOptions">
      <operation-select-major @change="majorChangeFn"
                              :refresh-region-list="refreshRegionList"
                              @operateMoreMajor="calcTableHeight"
                              parentRegion="quota">
      </operation-select-major>
      <div class="list"  :style="{'height': isFixed?'91px':''}">
        <div :class="{'fixed':isFixed, 'fold-menu': foldMenu}">
          <!-- 按钮组 -->
          <operation-buttons :button-list="buttonList"
                            @clickHandle="topButtonClick"
                             origin="database"
                            @uploadHandle="uploadHandle"
                            type="quota"
                             :disabled-button="disabledButton"
                             :tip-content="tipContent"
                            class="float_left">
          </operation-buttons>

          <!-- 高级搜索 -->
          <dialog-senior-search :key="refreshRegionList" class="float_right"
                                page="quota"
                                @onSearch="seniorSearchHandle">
          </dialog-senior-search>

          <!-- 搜索 -->
          <operation-search :key="refreshRegionList" class="float_right" @onSearch="searchHandle">
          </operation-search>
        </div>
      </div>
    </div>


    <!-- 移动到 弹窗 -->
    <dialog-move-to :show="dialog.moveTo.show"
                    @submit="moveToSubmit"
                    @cancel="dialog.moveTo.show = false"
                    :edit-data="dialog.moveTo.data">
    </dialog-move-to>

    <div>
      <div class="tree-table fit flex flex-column table-medium table-beyond-hiding" :style="{height: tableHeight + 'px'}" id="tree-table">
        <div class="header-wrapper" ref="headerWrapper">
          <div class="table-header flex flex-row" :style="{width: (scrollY ? (tableWidth + 17) : tableWidth) + 'px'}">
            <div class="header-item is-leaf is-center" style="width: 40px;">
              <label>
                <!-- 表头那个全选 下拉框 -->
                <select-all
                  :reset-select-all="resetSelectAll"
                  :current-page-item-count="dataList.length"
                  :current-page-item-selected="selectItems.length"
                  :pageTotal="pageCount"
                  :top="31"
                  :left="-13"
                  @change="selectAllChange"
                ></select-all>
              </label>
            </div>
            <div class="header-item is-leaf is-left" style="width: 30px;"></div>
            <div class="header-item is-leaf is-left" style="width: 80px;">编码</div>
            <div class="header-item is-leaf is-left flex-1">名称</div>
            <div class="header-item is-leaf is-center" style="width: 60px;">单位</div>
            <div class="header-item is-leaf is-center" style="width: 80px;">单价(元)</div>
            <div class="header-item is-leaf is-left" style="width: 20px;"></div>
            <template v-if="pageType === 'databaseBasis'">
              <div class="header-item is-leaf is-center" style="width: 120px;">上传人</div>
            </template>
            <div class="header-item is-leaf is-center" style="width: 80px;">
              <span class="person-sort" @click="changeSort('time')">
                        上传时间
                        <i class="sort" :class="parameter.timeSort === 1 ? 'sort-down': (parameter.timeSort === 0 ?'sort-up' : '')"></i>
                      </span>
            </div>
            <template v-if="pageType === 'databaseBasis'">
              <div class="header-item is-leaf is-center" style="width: 100px;">数据来源</div>
              <div class="header-item is-leaf is-center" style="width: 100px;">审核人</div>
              <div class="header-item is-leaf is-center" style="width: 120px;">
                <em class="sort-btn-fixed position-relative cursor-pointer" @click="changeSort('inspected')">
                  审核状态
                  <i :class="parameter.inspectedSort === 0 ? 'sort-up' : parameter.inspectedSort === 1 ? 'sort-down' : 'sort'"></i>
                </em>
              </div>
            </template>
            <div class="header-item is-leaf is-center" style="width: 100px;"></div>
            <div class="has-gutter" v-if="scrollY"></div>
          </div>
        </div>
        <div class="body-wrapper flex-1" style="overflow: auto;" ref="bodyWrapper">
          <ul class="container" :style="{width: tableWidth + 'px'}" ref="containerWrapper">
            <template v-for="(item, index) in dataList">
              <li class="flex flex-row row row--level-1">
                <div class="cell column_1 is-left" style="width: 40px;">
                  <w-checkbox @change="checkboxTap(item)" v-model="item.checked"/>
                </div>
                <div class="cell column_2 is-left" style="width: 30px;">
                  <a class="view-more" :class="{close:item.childshow}"  @click="itemUnfoldTap(index)"></a>
                </div>
                <div class="cell column_3 is-left" style="width: 80px;">{{item.code}}</div>
                <div class="cell column_4 is-left flex-1">{{item.description}}</div>
                <div class="cell column_5 is-center" style="width: 60px;">{{item.unit}}</div>
                <div class="cell column_6 is-center" style="width: 80px;">{{item.normRate || ''}}</div>
                <div class="cell column_7 is-center" style="width: 20px;">
                  <span v-if="+item.normRate !== 0">
                      <span v-if="parameter.region === '重庆' || parameter.region === '贵州'">

                      </span>
                      <span v-else-if="parameter.region === '河南'">
                        <i class="tax-no" v-if="+item.taxMethod === 1  || +item.taxMethod === 5 "></i>
                        <i class="tax" v-else></i>
                      </span>
                      <span v-else>
                        <i class="tax-no" v-if="+item.rateType === 2"></i>
                        <i class="tax" v-else></i>
                      </span>
                    </span>
                </div>
                <template v-if="pageType === 'databaseBasis'">
                  <div class="cell column_8 is-center" style="width: 120px;">{{item.authorIdStr}}</div>
                </template>
                <div class="cell column_9 is-center" style="width: 80px;">{{item.createTimeStr}}</div>
                <template v-if="pageType === 'databaseBasis'">
                  <div class="cell column_10 is-center" style="width: 100px;">{{item.source}}</div>
                  <div class="cell column_11 is-center" style="width: 100px;"><span>{{!item.inspector && +item.inspected > 0 ? '无需审核' : item.inspector}}</span>
                  </div>
                  <div class="cell column_12 is-center" style="width: 120px;">
                    <span>
                      <template v-if="+item.inspected === 0">
                        <span :class="['action-accept', item.professionAllowed ? '' : 'invalid']"
                              @click="dealItem('inspect', item, index, true)">通过</span>
                        <span :class="['action-reject', item.professionAllowed ? '' : 'invalid']"
                              @click="dealItem('inspect', item, index, false)">不通过</span>
                      </template>
                      <span class="inspect-status accept" v-else-if="+item.inspected === 1">审核通过</span>
                      <span class="inspect-status reject" v-else-if="+item.inspected === 2">审核未通过</span>
                    </span>
                  </div>
                </template>
                <div class="cell column_13 is-center" style="width: 100px;">
                  <el-tooltip content="删除">
                    <i class="r2-icon-action_delete_outline cursor-pointer margin-right-10" :class="[item.professionAllowed ? '' : 'invalid']"
                       @click.stop="dealItem('delete', item)">
                    </i>
                  </el-tooltip>
                  <el-tooltip content="移动到">
                    <i class="w-icon-yidong cursor-pointer" :class="[item.professionAllowed ? '' : 'invalid']"
                       @click.stop="dealItem('move', item);operateCurrentRow=true;">
                    </i>
                  </el-tooltip>
                </div>
              </li>
              <collapse>
                <li class="flex flex-row row row--level-2 padding-10-0 collapse" :key="item.normItemDataId" v-show="item.childshow">
                  <div class="tree-table fit flex flex-column table-medium table-beyond-hiding" v-if="!regionKeyData">
                    <div class="header-wrapper" ref="headerWrapper" style="background: #f1f7e3;">
                      <div class="table-header flex flex-row" :style="{width: (scrollY ? (tableWidth + 17) : tableWidth) + 'px'}">
                        <div class="header-item is-leaf is-center" style="width: 70px;"></div>
                        <div class="header-item is-leaf is-left" style="width: 80px;">编码</div>
                        <div class="header-item is-leaf is-left flex-1">名称</div>
                        <div class="header-item is-leaf is-center" style="width: 100px;">规格型号</div>
                        <div class="header-item is-leaf is-center" style="width: 40px;">单位</div>
                        <div class="header-item is-leaf is-center" style="width: 50px;">含量</div>
                        <div class="header-item is-leaf is-center" style="width: 100px;">含税市场价(元)</div>
                        <div class="header-item is-leaf is-center" style="width: 130px;">不含税市场价(元)</div>
                        <div class="header-item is-leaf is-center" style="width: 100px;">税率(%)</div>
                        <div class="header-item is-leaf is-center" style="width: 100px;"></div>
                      </div>
                    </div>
                    <div class="body-wrapper flex-1" style="overflow: auto;">
                      <ul class="container" :style="{width: tableWidth + 'px'}">
                        <template v-for="(childitem,childindex) in item.resList">
                          <li class="flex flex-row row row--level-3" :key="'child'+childindex">
                            <div class="cell column_1 is-left" style="width: 70px;"></div>
                            <div class="cell column_2 is-left" style="width: 80px;">{{childitem.code}}</div>
                            <div class="cell column_3 is-left flex-1">{{childitem.description}}</div>
                            <div class="cell column_4 is-center" style="width: 100px;">{{childitem.spec}}</div>
                            <div class="cell column_5 is-left" style="width: 40px;">{{childitem.unit}}</div>
                            <div class="cell column_6 is-left" style="width: 50px;">{{childitem.usage}}</div>
                            <div class="cell column_7 is-left" style="width: 100px;">{{childitem.marketRate}}</div>
                            <div class="cell column_8 is-left" style="width: 130px;">{{childitem.marketPreTaxRate}}</div>
                            <div class="cell column_9 is-left" style="width: 100px;">{{childitem.taxRatio}}</div>
                            <div class="cell column_10 is-center" style="width: 100px;"></div>
                          </li>
                        </template>
                      </ul>
                    </div>
                  </div>
                  <div class="tree-table fit flex flex-column table-medium table-beyond-hiding" v-else>
                    <div class="header-wrapper">
                      <div class="table-header flex flex-row" :style="{width: (scrollY ? (tableWidth + 17) : tableWidth) + 'px'}">
                        <div class="header-item is-leaf is-center" style="width: 70px;"></div>
                        <div class="header-item is-leaf is-left" v-for="(resItem,resIndex) in regionKeyData" :key="'resHead'+resIndex" :class="resItem.className" :width="resItem.width" :style="{width: resItem.width + 'px'}">{{resItem.name}}</div>
                        <div class="header-item is-leaf is-center" style="width: 100px;"></div>
                      </div>
                    </div>
                    <div class="body-wrapper flex-1" style="overflow: auto;">
                      <ul class="container" :style="{width: tableWidth + 'px'}">
                        <template v-for="(childitem,childindex) in item.resList">
                          <li class="flex flex-row row row--level-3" :key="'child'+childindex">
                            <div class="cell column_1 is-left" style="width: 70px;"></div>
                            <div class="cell is-left"
                                 v-for="(resItem, resIndex) in regionKeyData"
                                 :key="'res'+resIndex"
                                 :class="[resItem.className, 'column_' + (resIndex + 2)]"
                                 :style="{width: resItem.width + 'px'}">
                              <span v-if="resItem.or">{{childitem[resItem.key] || childitem[resItem.or]}}</span>
                              <span v-else>{{childitem[resItem.key]}}</span>
                            </div>
                            <div class="cell is-center" :class="'column_' + (regionKeyData.length + 2)" style="width: 100px;"></div>
                          </li>
                        </template>
                      </ul>
                    </div>
                  </div>
                </li>
              </collapse>
            </template>
          </ul>
        </div>
      </div>
      <!-- 表格 -->
      <simple-table :isHeight="false" v-if="false"
                    :showNoData="dataList.length === 0"
                    :is-empty="dataList.length < 1"
                    :is-scroll="false">
        <!-- 表头 -->
        <template slot="headTable">
          <div class="table-head-wrapper" :class="{'th-fixed':isFixed, 'fold-menu': foldMenu}">
            <table cellspacing="0" cellpadding="0" border="0" class="table-head">
              <thead class="has-gutter">
                <tr>
                    <th width="40" class="font-left">
                      <label class="checkbox-label th">
                        <!-- 表头那个全选 下拉框 -->
                        <select-all
                          :reset-select-all="resetSelectAll"
                          :current-page-item-count="dataList.length"
                          :current-page-item-selected="selectItems.length"
                          :pageTotal="pageCount"
                          :top="31"
                          :left="-6"
                          @change="selectAllChange"
                        ></select-all>
                      </label>
                    </th>
                    <th width="10"></th>
                    <th width="80" class="font-left">编码</th>
                    <th class="font-left">名称</th>
                    <th width="60" class="font-center">单位</th>
                    <th width="80" class="font-right">单价(元)</th>
                    <th width="20"></th>
                    <th width="120" class="font-left" v-if="pageType === 'databaseBasis'">上传人</th>
                    <th width="80" class="font-center">
                      <span class="person-sort" @click="changeSort('time')">
                        上传时间
                        <i class="sort" :class="parameter.timeSort === 1 ? 'sort-down': (parameter.timeSort === 0 ?'sort-up' : '')"></i>
                      </span>
                    </th>

                    <!-- R2  第二迭代 去掉地区列 -->
                    <!--<th width="80" class="font-center">地区</th>-->

                    <template v-if="pageType === 'databaseBasis'">
                      <th class="font-left" width="100">数据来源</th>
                      <th class="font-left" width="100">审核人</th>
                      <!-- 审核状态 -->
                      <th class="font-left" width="120">
                        <em class="sort-btn-fixed position-relative cursor-pointer" @click="changeSort('inspected')">
                          审核状态
                          <i :class="parameter.inspectedSort === 0 ? 'sort-up' : parameter.inspectedSort === 1 ? 'sort-down' : 'sort'"></i>
                        </em>
                      </th>
                    </template>
                    <th width="100"></th>
                  </tr>
              </thead>
            </table>
          </div>
        </template>
        <!-- 表主体 -->
        <template slot="body" v-if="dataList.length>0">
          <tbody id="projectContent">
            <template  v-for="(item,index) in dataList">
                <tr class="trItem" :key="index" >
                  <td width="40" class="font-left">
                    <label class="checkbox-label">
                      <!--<input type="checkbox" @click="checkboxTap(item)" v-model="item.checked"/>-->
                      <w-checkbox @change="checkboxTap(item)" v-model="item.checked"/>
                    </label>
                  </td>
                  <td width="10"><a class="view-more" :class="{close:item.childshow}"  @click="itemUnfoldTap(index)"></a></td>
                  <td width="80" class="font-left">{{item.code}}</td>
                  <td class="font-left">{{item.description}}</td>
                  <td width="60" class="font-center">{{item.unit}}</td>
                  <td width="80" class="font-right">{{item.normRate || ''}}</td>
                  <td width="20" class="font-center">
                    <span v-if="+item.normRate !== 0">
                      <span v-if="parameter.region === '重庆' || parameter.region === '贵州'">

                      </span>
                      <span v-else-if="parameter.region === '河南'">
                        <i class="tax-no" v-if="+item.taxMethod === 1  || +item.taxMethod === 5 "></i>
                        <i class="tax" v-else></i>
                      </span>
                      <span v-else>
                        <i class="tax-no" v-if="+item.rateType === 2"></i>
                        <i class="tax" v-else></i>
                      </span>
                    </span>
                  </td>
                  <td width="120" class="font-left" v-if="pageType === 'databaseBasis'">{{item.authorIdStr}}</td>
                  <td width="80" class="font-center">{{item.createTimeStr}}</td>

                  <!-- R2  第二迭代 去掉地区列 -->
                  <!--<td width="80" class="font-center">{{item.region}}</td>-->
                  <template v-if="pageType === 'databaseBasis'">
                    <td class="font-left" width="100">{{item.source}}</td>
                    <td class="font-left" width="100">
                      {{!item.inspector && +item.inspected > 0 ? '无需审核' : item.inspector}}
                    </td>
                    <!-- 审核状态 -->
                    <td class="font-left" width="120">
                      <div class="action-inspect" v-if="+item.inspected === 0">
                        <span :class="['action-accept', item.professionAllowed ? '' : 'invalid']"
                              @click="dealItem('inspect', item, index, true)">通过</span>
                        <span :class="['action-reject', item.professionAllowed ? '' : 'invalid']"
                              @click="dealItem('inspect', item, index, false)">不通过</span>
                      </div>
                      <span class="inspect-status accept" v-else-if="+item.inspected === 1">
                    审核通过
                  </span>
                      <span class="inspect-status reject" v-else-if="+item.inspected === 2">
                    审核未通过
                  </span>
                    </td>
                  </template>
                  <td width="100" class="td-btnbox operation">
                    <el-tooltip content="删除">
                      <a :class="['r2-icon-action_delete_outline', item.professionAllowed ? '' : 'invalid']"
                         @click.stop="dealItem('delete', item)">
                      </a>
                    </el-tooltip>
                    <el-tooltip content="移动到">
                      <a :class="['w-icon-yidong', item.professionAllowed ? '' : 'invalid']"
                         @click.stop="dealItem('move', item);operateCurrentRow=true;">
                      </a>
                    </el-tooltip>
                  </td>
              </tr>
              <tr class="more-hidden" :key="item.normItemDataId" v-show="item.childshow">
                <td :colspan="pageType === 'databaseBasis' ? 13 : 9">
                  <table class="table-light table-layout ui-mt10" width="100%" cellspacing="0" cellpadding="0"  v-if="!regionKeyData">
                    <thead>
                      <tr class="h-34">
                        <th width="80"></th>
                        <th width="100" class="font-left">编码</th>
                        <th width="150" class="font-left break-word-wrap">名称</th>
                        <th width="100" class="font-center">规格型号</th>
                        <th width="40" class="font-center">单位</th>
                        <th width="50" class="font-right">含量</th>
                        <th width="100" class="font-right">含税市场价(元)</th>
                        <th width="100" class="font-right">不含税市场价(元)</th>
                        <th width="100" class="font-right">税率(%)</th>
                        <th width="100"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr  class="h-32" v-for="(childitem,childindex) in item.resList" :key="'child'+childindex">
                        <td width="80"></td>
                        <td width="100" class="font-left">{{childitem.code}}</td>
                        <td class="font-left">{{childitem.description}}</td>
                        <td class="font-center break-word-wrap">{{childitem.spec}}</td>
                        <td class="font-center">{{childitem.unit}}</td>
                        <td class="font-right">{{childitem.usage}}</td>
                        <td class="font-right">{{childitem.marketRate}}</td>
                        <td class="font-right">{{childitem.marketPreTaxRate}}</td>
                        <td class="font-right">{{childitem.taxRatio}}</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="table-light table-layout ui-mt10" width="100%" cellspacing="0" cellpadding="0"  v-else>
                    <thead>
                      <tr>
                        <th width="80"></th>
                        <th v-for="(resItem,resIndex) in regionKeyData" :key="'resHead'+resIndex" :class="resItem.className" :width="resItem.width">{{resItem.name}}</th>
                        <th width="100"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(childitem,childindex) in item.resList" :key="'child'+childindex">
                        <td width="80"></td>
                        <td v-for="(resItem,resIndex) in regionKeyData" :key="'res'+resIndex" :class="resItem.className">
                          <span v-if="resItem.or">{{childitem[resItem.key] || childitem[resItem.or]}}</span>
                          <span v-else>{{childitem[resItem.key]}}</span>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              </template>
          </tbody>
        </template>
        <!--<div slot="body" v-else class="empty-box cursor-pointer" @click="openHelp">-->
          <!--<img src="@/assets/images/default_empty.png" />-->
          <!--<p>点击这里上传您的第一条定额数据</p>-->
        <!--</div>-->
        <template slot="no-data">
          <a href="/doc/guide_quota.html" target="_blank">点击这里</a>
          上传您的第一条定额数据
        </template>
      </simple-table>
    </div>
    <!-- 分页区域 -->
    <div class="page-box" v-if="totalCount > 0">
      <w-pagination
        @current-change="changePageCurrent"
        @size-change="changePageSize"
        :current-page.sync="parameter.pageNo"
        background
        layout="total, prev, pager, next, jumper, sizes"
        :page-size="parameter.pageSize"
        :page-sizes="[50, 100, 150, 200]"
        :total="totalCount">
      </w-pagination>
    </div>
    <!-- 结果 -->
    <w-dialog @close="upload.show=!upload.show"  :show="upload.show">
      <span class="w__dialog--title" slot="header">{{upload.title}}</span>
      <p>{{upload.text}}</p>
      <div v-if="upload.detailShow && upload.detail.length">
        <br />
        <p>未导入原因：</p>
        <p id="upload_result1">1、已存在相同数据</p>
      </div>
      <div slot="footer">
        <w-button type="minor" v-if="upload.detail.length" @click="showDetail">查看详情</w-button>
        <w-button type="primary" @click="upload.show=!upload.show">确认</w-button>
      </div>
    </w-dialog>
    <!-- 返回顶部 -->
    <w-backtotop
      scroll-el="scrollBody"
      transition-name="bottomToTop"
      hover-text="返回顶部"
      hover-class="hover-class"
      :back-position="0"
      :visibility-height="110"
      icon-name="w-icon-xiala-copy icon-demo"
      custom-class="demo-3-class"
    ></w-backtotop>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import { backendUrl } from '@/assets/js/config'
import {OperationSelectMajor, DialogSeniorSearch, OperationButtons, OperationSearch, SelectAll, Collapse, DialogMoveTo, SimpleTable} from '@/components/common'
import QuotaService from '@/assets/service/quota'
import { getCookie } from '@/assets/utils/CommonUtil'
import getRegionKey from './QuotaData'
import {on, off, isIE } from '@/assets/utils'

import databaseBasisMixin from '@/assets/mixins/database-basis'
let unSelectedIds = []
export default {
  name: 'DatabaseQuota',
  components: {
    DialogSeniorSearch,
    OperationButtons,
    OperationSearch,
    OperationSelectMajor,
    SelectAll,
    Collapse,
    DialogMoveTo,
    SimpleTable
  },
  mixins: [databaseBasisMixin],
  data () {
    return {
      tableWidth: 0,
      scrollY: false,
      refreshRegionList: 0,
      resetSelectAll: 0,
      buttonList: ['uploadBtn', 'export', 'copyToCompanySpace', 'move', 'inspectBatch', 'delete'],
      dialog: { // 弹窗
        moveTo: {
          show: false, // 弹窗显示
          data: {}
        }
      },
      selectPage: '', // 全选下拉框 已选中的值 current: 当前页、all: 所有页
      totalCount: 0,
      pageCount: 0,
      dataList: [],
      isCheckAll: false,
      sortType: 1,
      parameter: {
        authorId: null, // 上传人ID
        code: null, // code
        description: null,
        inspected: null, // 是否审查，true：审查，false：不审查
        pageNo: 1, // 页码，从 1 开始
        pageSize: 50, // 每页多少条
        profession: null, // 专业
        region: null, // 地区
        timeSort: null, // 排序顺序：1:降序，0:升序
        inspectedSort: null // 审核状态 排序顺序：1:降序，0:升序
      },
      editData: {}, // 操作 要提交的数据 暂存这里
      currentPageItemCount: 20,
      currentPageItemSelected: 0,
      regionKeyData: '',
      isFixed: false,
      upload: {
        // 更新&复制
        show: false,
        text: '',
        title: '',
        detail: [],
        detailShow: false
      },
      user: {},
      operateCurrentRow: false
    }
  },
  computed: {
    ...mapState({
      foldMenu: state => state.menus.foldMenu // 是否折叠菜单
    }),
    selectItems () {
      let selectItems = []
      this.dataList.forEach(item => {
        if (item.checked) {
          selectItems.push(item)
        }
      })
      return selectItems
    }
  },
  watch: {
    foldMenu (newVal, oldVal) {
      if (newVal !== oldVal) {
        setTimeout(() => {
          this.calcTableHeight()
        }, 500)
      }
    },
    totalCount (val){
      this.pageCount = Math.ceil(val / this.parameter.pageSize)
    }
  },
  methods: {
    calcTableHeight () {
      let tableWidth = 720
      if (this.pageType === 'databaseBasis') {
        tableWidth += 440
      }
      if (tableWidth < this.getDomWidth('scrollBody') - 20) {
        tableWidth = this.getDomWidth('scrollBody') - 20
      }
      if (this.scrollY) {
        tableWidth -= 17
      }
      this.tableWidth = tableWidth
      this.tableHeight = this.getTableHeight('scrollBody') - this.getTableHeight('contentOptions') - 30
    },
    // 滚动条滚动事件
    handleScroll (event) {
      this.$refs.headerWrapper.scrollLeft = this.$refs.bodyWrapper.scrollLeft
    },
    // handleScroll() {
    //   if (document.getElementsByClassName('list')[0].getBoundingClientRect().top < 56) {
    //     this.isFixed = true
    //   } else {
    //     this.isFixed = false
    //   }
    // },
    // 1. 修改专业、切换地区时 触发
    majorChangeFn (obj) {
      this.calcTableHeight()
      // 选定的地区记录到浏览器里
      sessionStorage.setItem('quota_' + this.user.gldUserId, obj.region)

      console.log('majorChangeFn', obj)
      this.parameter.region = obj.region
      if (obj.major){
        this.parameter.profession = obj.major
      } else {
        this.parameter.profession = null
      }
      this.regionKeyData = getRegionKey(obj.region)
      this.parameter.pageNo = 1
      this.getNormList()
    },
    // 2. 搜索
    searchHandle (name) {
      this.parameter.description = name
      this.parameter.pageNo = 1
      this.getNormList()
    },
    // 2.1 高级搜索
    seniorSearchHandle (obj) {
      this.parameter.authorId = obj.authorId
      this.parameter.code = obj.code
      this.parameter.description = obj.descOrSpec
      this.parameter.description = obj.descOrSpec // 搜索值转换，线上遗留
      this.parameter.inspected = obj.inspected
      this.parameter.pageNo = 1
      this.getNormList()
    },
    // 3.2 顶部其他按钮点击
    topButtonClick (type) {
      console.log('topButtonClick==', type)
      switch (type) {
        case 'export':
        case 'copyToCompanySpace':
        case 'move':
        case 'inspectBatch':
        case 'delete':
          this.dealItem(type)
          break
        case 'refresh':
          this.parameter.authorId = ''
          this.parameter.code = ''
          this.parameter.descOrSpec = ''
          this.parameter.inspected = ''
          this.parameter.description = ''
          this.parameter.pageNo = 1
          this.refreshRegionList++
          this.getNormList()
          break
        default:
      }
    },
    // 4.0 操作统一 在这里来封装数据
    dealItem (type, item, idx, value) {
      if (item) {
        if (['inspect', 'edit', 'delete', 'move'].includes(type) && !item.professionAllowed) {
          // 单条操作 时 无权限 则直接返回
          return
        }
        this.operationBatch = false
      } else {
        if (type === 'export' && this.pageType === 'databaseBasis' && this.role !== 2) {
          // 总负责人 才能导出 电子档案室的数据
          return
        }
        this.operationBatch = true
      }
      const operations = {
        edit: '修改',
        inspect: '审核',
        inspectBatch: '审核',
        delete: '删除',
        move: '移动',
        copyToCompanySpace: '复制',
        export: '导出'
      }
      let params = {
        modelType: '_normItem',
        normItemId: '',
        authorId: this.parameter.authorId,
        code: this.parameter.code,
        description: this.parameter.description,
        inspected: this.parameter.inspected,
        profession: this.parameter.profession,
        region: this.parameter.region,
        selectAllPages: false,
        unSelectedIds: '',
        selectCount: 0
      }
      if (item) {
        params.selectCount = 1
        params.normItemId = item.normItemDataId // 定额 id
        params.profession = item.professionGuid // 专业ID
        params.selectAllPages = false
      } else {
        // 批量操作
        params.selectAllPages = this.selectPage === 'all'
        params.normItemId = ''
        if (this.selectPage === 'all') {
          if (this.dataList.length) {
            // 批量操作 所有页面时 未选择项 id 需传递给后台
            params.unSelectedIds = unSelectedIds.join(',')
            params.selectCount = this.totalCount - unSelectedIds.length
          }
        } else {
          // 批量操作 当前页时
          this.dataList.forEach((row) => {
            if (row.checked) {
              params.selectCount++
              params.normItemId += row.normItemDataId + ','
            }
          })
          params.normItemId = params.normItemId.replace(/,$/, '')
        }
      }
      if (!params.selectCount) {
        this.$message.info('请勾选要' + operations[type] + '的定额数据')
        return
      }
      this.editData = params
      console.log(params)
      switch (type) {
        case 'export':
          this.$confirm({
            message: '确定导出勾选的定额数据？',
            tips: '',
            dealData: params,
            submit: (data) => {
              this.exportNormData(data)
            },
            cancel: () => {},
            submitText: '确定'
          })
          break
        case 'copyToCompanySpace':
          this.$confirm({
            message: '确定要将勾选的定额数据复制到电子档案室？',
            width: 400,
            dealData: params,
            submitText: '确定复制',
            submit: () => {
              this.copyNormData(params)
            },
            cancel: () => {}
          })
          break
        case 'delete':
          let message = '确定删除？'
          if (!item) {
            if (this.selectPage === 'all') {
              message = `确定删除所有页（共${this.pageCount}页）数据？`
            } else {
              message = '确定删除勾选的定额数据？'
            }
          }
          this.$confirm({
            message,
            type: 'warning',
            tips: '删除后，数据将不可恢复',
            dealData: params,
            width: 370,
            submit: data => {
              this.deleteConfirm(data)
            },
            cancel: () => {},
            submitText: '确定删除'
          })
          break
        case 'move':
          const selectItems = params.normItemId.split(',')
          if (selectItems && selectItems.length) {
            let catalogIdGuid = ''
            this.dataList.forEach((tr) => {
              if (tr.normItemDataId === selectItems[0]) {
                catalogIdGuid = tr.normCatalogIdGuid
              }
            })
            if (catalogIdGuid) {
              QuotaService.getQuotaChapter({catalogIdGuid}).then(res => {
                console.log(res)
                if (+res.code === 200 && res.data) {
                  this.dialog.moveTo.data = {
                    professionSelect: res.data.profession, // 当前所属的专业
                    chapterSelect: res.data.chapter // 当前所属的章节
                  }
                }
                this.dialog.moveTo.show = true
              })
            } else {
              this.dialog.moveTo.show = true
            }
          }
          break
        case 'inspect':
          this.inspectedQuota(item, value)
          break
        case 'inspectBatch':
          this.inspectedQuotaBatch(params)
          break
        default:
      }
    },
    // 4.1 导出定额
    exportNormData (params){
      let taskComplete = false
      const cacheKey = new Date().getTime()
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          if (+result.code === 200){
            // 操作记录
            this.addOperationRecords(2, params.selectCount)
            let token = getCookie('ZJYTOKEN')
            let name = result.data
            if (isIE()){
              name = encodeURIComponent(name)
            } else {
              name = decodeURIComponent(name)
            }
            setTimeout(() => {
              window.location.href = `${backendUrl}/data_manage/norm/export?fileName=${name}&token=${token}`
            }, 1000)
          }
        }
      }
      QuotaService.exportNormData(Object.assign(params, {cacheKey})).then((res) => {
        if (+res.code === 290004) {
          //  无权限操作数据 操作失败时
          if (window.exportProgressTimerEmitter){ clearTimeout(window.exportProgressTimerEmitter) }
          if (window.exportProgressTimer) {
            clearTimeout(window.exportProgressTimer) // 清除 轮询获取获取移动进度条的 计时器
          }
          this.$progress({closeAll: true}) // 关闭进度条弹窗
          if (this.operationBatch) {
            this.topButtonClick('refresh')
          } else {
            this.$message.error('操作失败')
          }
        } else {
          result = res
          afterTask()
        }
      })
      this.getProgress('export', 0, cacheKey).then(() => {
        taskComplete = true
        afterTask()
      })
    },
    // 4.2 复制到电子档案室
    copyNormData (params) {
      let taskComplete = false
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          if (+result.code === 200) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.resetSelectAll++
                this.selectAllChange('', false)
                this.upload.title = '复制结果'
                this.upload.detailShow = true
                this.upload.show = true
                this.upload.text = `复制总条数 ${result.data.CopyCompanyDataErr +
                result.data.CopyCompanyDataOK}， 复制成功 ${result.data.CopyCompanyDataOK}  条，复制失败  ${result.data.CopyCompanyDataErr} 条`
                this.upload.detail = []
                if (result.data.CopyCompanyDataErr > 0) {
                  this.upload.detail = result.data.ErrDetail
                }
              }, 1000)
            })
          }
          this.topButtonClick('refresh')
        }
      }
      QuotaService.copyNorm(params).then(res => {
        result = res
        afterTask()
      })
      this.getProgress('copy', 1, params.modelType).then(({hit}) => {
        taskComplete = true
        afterTask()
      })
    },
    // 4.3 删除 定额数据
    deleteConfirm (params){
      QuotaService.deleteNormData(params).then((res) => {
        if (+res.code === 200){
          // 删除完更新全选框
          this.resetSelectAll++
          unSelectedIds = []
          // 操作记录
          this.addOperationRecords(1, params.selectCount)
          if (this.operationBatch) {

          } else {
            this.$message.success('删除成功')
          }
          this.topButtonClick('refresh')
        } else {
          //  +data.code === 290004 无权限操作数据时 操作失败
          if (this.operationBatch) {
            this.topButtonClick('refresh')
          } else {
            this.$message.error('操作失败')
          }
        }
      })
    },
    // 4.4 移动到 确定
    moveToSubmit (data) {
      this.dialog.moveTo.show = false
      let taskComplete = 0
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          if (+result.code === 200 || (taskComplete > 1 && +result.code === -1)){
            !this.operationBatch && (this.$message.success('移动成功'))
            // 操作记录
            this.addOperationRecords(4, this.editData.selectCount)
          } else {
            !this.operationBatch && (this.$message.error(result.message || '移动失败'))
          }
          this.topButtonClick('refresh')
        }
      }
      const params = Object.assign(this.editData, {
        professionSelect: data.professionSelect,
        chapterSelect: data.chapterSelect
      })
      QuotaService.moveNormData(params).then((res) => {
        console.log('moveNormData===', res)
        if (+res.code === 290004) {
          //  无权限操作数据 操作失败时
          if (window.moveProgressTimerEmitter){ clearTimeout(window.moveProgressTimerEmitter) }
          if (window.moveProgressTimer) {
            clearTimeout(window.moveProgressTimer) // 清除 轮询获取获取移动进度条的 计时器
          }
          this.$progress({closeAll: true}) // 关闭进度条弹窗
          if (this.operationBatch) {
            this.topButtonClick('refresh')
          } else {
            this.$message.error('操作失败')
          }
        } else {
          result = res
          afterTask()
        }
      })
      this.getProgress('move', 0, this.editData.modelType).then(({hit}) => {
        taskComplete = hit
        afterTask()
      })
    },
    // 4.5 审核 单条定额
    inspectedQuota (item, value){
      let parameter = {
        inspection: value || false,
        normItemId: item.normItemDataId
      }
      this.loading = true
      QuotaService.putInspect(parameter).then((res) => {
        if (+res.code === 200){
          this.topButtonClick('refresh')
        } else {
          //  +data.code === 290004 无权限操作数据 操作失败时
          this.$message.error('操作失败')
          this.loading = false
        }
      })
    },
    // 4.6 批量 通过审核  定额
    inspectedQuotaBatch (params) {
      this.loading = true
      QuotaService.inspectBatch({inspection: true}, params).then(res => {
        // console.log(res)
        if (+res.code === 200) {
        } else {
          // +data.code === 290004 无权限操作数据 操作失败时
          // this.$message.error('操作失败')
        }
        this.topButtonClick('refresh')
      })
    },
    uploadHandle (files, e, type) {
      // 平台接口
      if (type === 'Platform') {
        if (files[0].name.substring(files[0].name.lastIndexOf('.'), files[0].name.length) !== '.DEYPT') {
          this.$message.warning({
            message: '不支持此格式文件导入,请选择正确的文件'})
          return
        }
        let formData = new FormData()
        formData.append('file', files[0])
        let query = {
          userType: this.user.userType
        }

        let taskComplete = false
        const cacheKey = new Date().getTime()
        let result = null
        const afterTask = () => {
          // 进度到100%、并且有有返回数据时执行
          if (taskComplete && result) {
            if (+result.code === 200) {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.upload.title = '导入结果'
                  this.upload.show = true
                  this.upload.text = `定额总条数 ${result.data.allCount} ，导入 ${result.data.importedCount}  条，未导入 ${result.data.unImportedCount} 条`
                  this.upload.detail = []
                  this.upload.detailShow = true
                  if (result.data.unImportedCount) {
                    this.upload.detail = result.data.items
                  }
                }, 300)
              })
            } else {
              this.$message.error('上传失败')
            }
            this.topButtonClick('refresh')
          }
        }
        formData.append('cacheKey', cacheKey)
        QuotaService.uploadItems(formData, query).then(res => {
          result = res
          afterTask()
        })
        this.getProgress('upload', '', cacheKey).then(() => {
          taskComplete = true
          afterTask()
        })
      }
    },
    // 6. 全选下拉框 切换时
    selectAllChange (type, value) {
      unSelectedIds = []
      this.selectPage = type
      if (!value && this.selectPage === 'all') {
        this.selectPage = ''
      }
      let list = JSON.parse(JSON.stringify(this.dataList))
      list.forEach((item) => {
        item.checked = value
      })
      this.dataList = list
    },
    // 分页
    changePageCurrent (data){
      this.parameter.pageNo = data
      this.getNormList(true)
    },
    changePageSize (data){
      this.parameter.pageNo = 1
      this.parameter.pageSize = data
      this.getNormList()
    },
    // 获取列表
    getNormList (pageChange){
      this.loading = true
      let parameter = this.parameter
      this.totalCount = 0
      QuotaService.getNormList(parameter).then((res) => {
        this.dataList = []
        if (+res.code === 200){
          if (!pageChange){
            this.resetSelectAll++
            this.selectAllChange('', false)
          }
          if (res.data.items){
            res.data.items.forEach((item) => {
              // console.log(item.normItemDataId)
              if (this.selectPage === 'all' && unSelectedIds.indexOf(item.normItemDataId) === -1){
                item.checked = true
              } else {
                item.checked = false
              }
            })
            this.dataList = this.verifyPermission(res.data.items)
            console.log(this.dataList)
            this.totalCount = res.data.total
          }
          console.log('dataList===', this.dataList)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 展开
    itemUnfoldTap (index){
      let dataList = JSON.parse(JSON.stringify(this.dataList))
      dataList[index].childshow = !dataList[index].childshow
      this.dataList = dataList
    },
    // 排序
    changeSort (type){
      switch (type) {
        case 'time':
          this.parameter.inspectedSort = ''
          this.parameter.timeSort = +this.parameter.timeSort === 0 ? 1 : 0
          break
        case 'inspected':
          this.parameter.timeSort = ''
          this.parameter.inspectedSort = +this.parameter.inspectedSort === 0 ? 1 : 0
          break
        default:
      }
      this.parameter.pageNo = 1
      this.getNormList()
    },
    // 每一行数据 复选框 点击
    checkboxTap (item){
      // console.log(item)
      // item.checked 是 修改后的值
      if (this.selectPage === 'all'){
        if (!item.checked){
          if (unSelectedIds.indexOf(item.normItemDataId) === -1){
            unSelectedIds.push(item.normItemDataId)
          }
        } else {
          if (unSelectedIds.indexOf(item.normItemDataId) > -1){
            unSelectedIds.splice(unSelectedIds.indexOf(item.normItemDataId), 1)
          }
        }
      }
    },
    // 3.3 上传结果查看详情
    showDetail () {
      var win = window.open()
      // 流使用结束后 必须要关闭
      let htmlStr = ''
      this.upload.detail.map(item => {
        if (this.upload.title === '复制结果') {
          htmlStr += `<tr>
            <td>${item.CopyCompanyDataCode}</td>
            <td>${item.CopyCompanyDataName}</td>
            <td>${item.CopyCompanyDataRepeat === true ? '重复' : ''}</td>
          </tr>`
        } else {
          htmlStr += `<tr>
            <td>${item.code}</td>
            <td>${item.name}</td>
            <td>${item.result}</td>
          </tr>`
        }
      })
      win.document.write(`<head>
        <title>${this.upload.title === '复制结果' ? '复制' : '导入'}详情</title>
        <meta http-equiv="Content-Type" content="text/html;charset=utf-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge, chrome=1">
        <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">
        <style>
          *{margin:0;padding: 0;}
            .info{
              width: 1000px;
              margin: 20px auto;
            }
            table{
              border: 1px solid #ccc;
              border-collapse: collapse;
              border-spacing: 0;
              font-size: 14px;
            }
            caption{
              padding:8px 5px;
              border: 1px solid #ccc;
              border-bottom: none;
              text-align: left;
              font-size: 20px;
            }
            caption a{
              color: #2079FA;
              text-decoration: none;
              float: right;
            }
            tr{
              height: 30px;
            }
            tr:hover td{
              background-color: #E6F9FF;
            }
            th,
            td{
              padding:8px 5px;
              border: 1px solid #ccc;
              text-align: left;
            }
            th{
              background-color: #EEE;
              color: #666;
            }
          </style>
        </head>
        <body>
        <div class="info" id="___info">
          <table width="100%" cellspacing="0" cellpadding="0">
            <caption>${
  this.upload.title === '复制结果' ? '复制' : '定额导入'
}详情<a href="javascript:window.print()">打印</a></caption>
            <thead>
              <tr>
                <th width="200">编码</th>
                <th>名称</th>
                <th>未导入原因</th>
              </tr>
            </thead>
            <tbody>
            ${htmlStr}
            </tbody>
          </table>
        </div>
        <body></head>`)
      win.document.close()
    }
  },
  mounted () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo){
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    on(this.$refs.bodyWrapper, 'scroll', this.handleScroll)
    // on(this.$refs.scrollBody, 'scroll', this.handleScroll)
    this.calcTableHeight()
    // 窗口大小改变时 触发
    this.resizeHandle.resize(() => {
      this.calcTableHeight()
    })
  },
  updated () {
    let scrollY
    try {
      scrollY = this.$refs.containerWrapper.clientHeight > this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
  },
  beforeDestroy () {
    off(this.$refs.bodyWrapper, 'scroll', this.handleScroll)
    // off(this.$refs.scrollBody, 'scroll', this.handleScroll)
  }
}
</script>
<style lang="less" type="text/less">
  @import "./index";
  .right-content .quota-main{
    .table-wrapper .table-head-wrapper{
      margin-right: 0px;
    }
   .table-wrapper .table-body-wrapper {
    overflow-y: hidden;
    tr {
      height: 46px;
      &.h-34{
        height: 34px;
      }
      &.h-32{
        height: 32px;
      }
      &.h-34, &.h-32{
        td {
          word-break: break-all;
          border-top: none!important;
        }
      }
    }
  }

  .content--options {
    padding-right: 0 !important;
  }
  .th-normal {
    height: 40px;
  }
  .empty-box {
      text-align: center;
    width: 100%;
    font-size: 26px;
    color: #999;
  }
  .w__dialog--box{
    width: 300px;
    .w__dialog--body{
      padding: 20px;
    }
  }
}
</style>

<style lang="less" scoped>

.view-more{
  display: inline-block;
	margin-top: 3px;
	width: 12px;
	height: 12px;
	background: transparent url("~@/assets/images/tree.png") 0 0 no-repeat
}
.close {
    background-position: 0 -54px;
}
.tax{
  display: inline-block;
  margin-right: 5px;
  width: 16px;
  height: 16px;
  background: transparent url("~@/assets/images/tax.png") 0 0 no-repeat;
}


.tax-no {
	display: inline-block;
	margin-right: 5px;
	width: 16px;
	height: 16px;
	background: transparent url("~@/assets/images/tax.png") 0 -16px no-repeat
}
.inspected-click{
  color: #ff561a !important;
  cursor: pointer;
}

.trItem .checkbox-td{
  text-align: left;
}

.trItem .td-btnbox{
  text-align: right;
  .font-green{
      color: #00C461 !important
  }
}
/*.checkbox-label{*/
  /*margin-left: 10px;*/
  /*&.th{*/
    /*margin-left: 7px;*/
  /*}*/
/*}*/
.table-light{
  margin-top: 10px;
  thead{
    th{
      height: 34px;
      padding: 0 5px;
      background-color: #f1f7e3;
      color: #666;
      font-size: 12px;
    }
  }
  tbody{
    td{
      /*padding: 10px 5px !important;*/
      color: #333;
      font-size: 12px;
      border-bottom: none !important;
    }
  }
}
.more-hidden td{
  background: #fff !important;
}
.shen-ok {
    border-radius: 2px;
    padding: 0 3px 2px 3px;
    font-size: 12px;
    background-color: #ff561a;
    color: #fff !important;
}
.r2-icon-action_delete_outline{
  margin-right: 10px;
}
.page-box {
  position: fixed;
  bottom: 10px;
  /*width: calc(100% - 220px);*/
  /*width: calc(100% - 260px);*/
  /*min-width: 1100px;*/
  right: 10px;
}
</style>
